(() => {
  const models = new WeakMap();
  let directoryPromise;
  const buildIndex = (root, strict = false) => {
    const source=root.querySelector('[data-fitment-source]');
    const onlineSource=root.querySelector('[data-online-fitments]');
    if(!source||(strict&&!onlineSource))throw new Error('Directory data missing');
    const groups=new Map();
    const entries=new Map();
    const linkedEntries=new Map();
    const normalize=(value)=>String(value||'').normalize('NFKD').toLowerCase().replace(/&/g,' and ').replace(/[–—]/g,'-').replace(/[^a-z0-9]+/g,' ').trim();
    const normalizeUrl=(value)=>{if(!value)return '';try{return new URL(value,window.location.origin).pathname.replace(/\/$/,'')}catch(error){return String(value).split(/[?#]/)[0].replace(/\/$/,'')}};
    const entryKey=(make,title)=>normalize(make)+'|'+normalize(title);
    const addEntry=(make,item)=>{
      const cleanMake=String(make||'').replace(/\s+tops$/i,'').trim();
      if(!cleanMake||!item.title)return;
      const key=entryKey(cleanMake,item.title);
      const urlKey=normalizeUrl(item.sourceUrl||item.url);
      const existing=entries.get(key)||(urlKey?linkedEntries.get(urlKey):null);
      if(existing){if(item.online){existing.online=true;existing.url=item.url}return existing}
      const years=new Set();
      const prefix=item.title.match(/^\d{4}(?:(?:\s*(?:[-–—]|through|to|&|and|,)\s*)\d{4})*/i)?.[0]||'';
      for(const range of prefix.matchAll(/(\d{4})(?:\s*(?:[-–—]|through|to)\s*(\d{4}))?/gi)){
        const start=Number(range[1]);const end=Number(range[2]||range[1]);
        if(end>=start&&end-start<=20)for(let year=start;year<=end;year+=1)years.add(String(year));
      }
      const entry={title:item.title,url:item.online?item.url:'',online:Boolean(item.online),search:(cleanMake+' '+item.title).toLowerCase(),years,sourceUrl:item.sourceUrl||''};
      if(!groups.has(cleanMake))groups.set(cleanMake,[]);
      groups.get(cleanMake).push(entry);
      entries.set(key,entry);
      if(urlKey)linkedEntries.set(urlKey,entry);
      return entry;
    };
    let current='';
    [...source.children].forEach((node)=>{
      if(node.matches('h2,h3')){const title=node.textContent.trim();if(title)current=title}
      if(node.matches('p')&&current){const title=node.textContent.trim();if(!title)return;const collectionLink=node.querySelector('a[href*="/collections/"]');addEntry(current,{title,sourceUrl:collectionLink?.getAttribute('href')||'',online:false})}
    });
    let online=[];
    try{online=JSON.parse(onlineSource?.textContent||'[]');if(!Array.isArray(online)||(strict&&online.some(item=>!item||typeof item.make!=='string'||!item.make.trim()||typeof item.title!=='string'||!item.title.trim()||typeof item.url!=='string'||!item.url.trim())))throw new Error('Invalid online fitments')}catch(error){if(strict)throw error;online=[]}
    online.forEach((item)=>addEntry(item.make,{title:item.title,url:item.url,sourceUrl:item.url,online:true}));
    return { groups, entries: [...entries.values()], labels: { ...root.dataset } };
  };
  const match = (items, query = '') => {
    const tokens=query.trim().toLowerCase().split(/\s+/).filter(Boolean);
    return items.filter(item=>!tokens.length||tokens.every(token=>/^\d{4}$/.test(token)?item.years.has(token):item.search.includes(token)));
  };
  const createCard = (item, labels) => {
    const article=document.createElement('article');article.className='fitment-item';const copy=document.createElement('div');const heading=document.createElement('h3');heading.textContent=item.title;const status=document.createElement('p');const dot=document.createElement('i');dot.className='status-dot'+(item.online?' status-dot--online':'');status.append(dot,document.createTextNode(item.online?labels.onlineLabel:labels.contactLabel));copy.append(heading,status);const link=document.createElement('a');link.href=item.online?item.url:labels.contactUrl+'?vehicle='+encodeURIComponent(item.title);link.textContent=item.online?labels.shopLabel:labels.quoteLabel;article.append(copy,link);
    return article;
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-fitment-directory]').forEach(root => {
      if (models.has(root)) return;
      const model=buildIndex(root);
      models.set(root,model);
      const groups=model.groups;
      const logoTemplates=new Map([...root.querySelectorAll('[data-make-logo]')].map(template=>[template.dataset.makeLogo.trim().toLowerCase(),template]));
    if(!groups.size)return;
    const container=root.querySelector('[data-fitment-groups]');
    const index=root.querySelector('[data-make-index]');
    const input=root.querySelector('[data-fitment-search]');
    const count=root.querySelector('[data-fitment-count]');
    const render=(query='')=>{
      const term=query.trim().toLowerCase();
      container.innerHTML='';
      index.innerHTML='';
      let visible=0;
      groups.forEach((items,make)=>{
        const matches=match(items,term);
        if(!matches.length)return;
        visible+=matches.length;
        const id='Make-'+make.toLowerCase().replace(/[^a-z0-9]+/g,'-');
        const jump=document.createElement('a');jump.href='#'+id;jump.textContent=make;index.append(jump);
        const details=document.createElement('details');details.className='fitment-make';details.id=id;details.open=Boolean(term);
        const summary=document.createElement('summary');const label=document.createElement('div');label.className='make-label';const logoTemplate=logoTemplates.get(make.toLowerCase());if(logoTemplate)label.append(logoTemplate.content.cloneNode(true));label.append(document.createTextNode(make));summary.append(label);const total=document.createElement('span');total.textContent=matches.length;summary.append(total);details.append(summary);
        const list=document.createElement('div');list.className='fitment-list';
        matches.forEach((item)=>list.append(createCard(item,root.dataset)));
        details.append(list);container.append(details);
      });
      count.textContent=visible+' '+(visible===1?root.dataset.singularLabel:root.dataset.pluralLabel);
    };
    render();
    input.addEventListener('input',()=>render(input.value));
    root.classList.add('is-enhanced');

    });
  };
  const loadDirectory = url => {
    if(directoryPromise)return directoryPromise;
    const existing=document.querySelector('[data-fitment-directory]');
    if(existing){directoryPromise=Promise.resolve().then(()=>buildIndex(existing,true));return directoryPromise;}
    directoryPromise=(async()=>{
      if(!url)throw new Error('Directory URL missing');
      const endpoint=new URL(url,location.origin);
      endpoint.searchParams.set('section_id','main-page');
      const response=await fetch(endpoint,{headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error('Directory request failed');
      const template=document.createElement('template');template.innerHTML=await response.text();
      const root=template.content.querySelector('[data-fitment-directory]');
      if(!root)throw new Error('Directory section missing');
      return buildIndex(root,true);
    })();
    return directoryPromise;
  };
  window.MegakronFitments={buildIndex,match,createCard,loadDirectory};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',event=>{if(event.target.querySelector('[data-fitment-directory]'))directoryPromise=undefined;initialize(event.target);});
})();
